import type { SerializedEvent } from '@/lib/matrix/events'

interface SystemEventProps {
  event: SerializedEvent
}

function getSystemText(event: SerializedEvent): string | null {
  const name = event.senderName
  const content = event.content as Record<string, unknown>

  switch (event.type) {
    case 'm.room.member': {
      const membership = content.membership as string
      const prevMembership = (event.unsigned?.prev_content as Record<string, unknown>)?.membership as string | undefined
      if (membership === 'join' && prevMembership !== 'join') return `${name} joined the room`
      if (membership === 'join' && prevMembership === 'join') return `${name} changed their display name`
      if (membership === 'leave' && prevMembership === 'join') {
        return event.stateKey === event.sender ? `${name} left the room` : `${name} was removed`
      }
      if (membership === 'invite') return `${name} invited ${event.stateKey?.replace(/@(.+?):.*/, '$1')}`
      if (membership === 'ban') return `${name} was banned`
      return null
    }
    case 'm.room.name':
      return `${name} changed the room name to "${content.name}"`
    case 'm.room.topic':
      return `${name} changed the topic to "${content.topic}"`
    case 'm.room.avatar':
      return `${name} changed the room avatar`
    case 'm.room.encryption':
      return '🔒 Encryption enabled for this room'
    case 'm.room.power_levels':
      return `${name} changed room permissions`
    default:
      return null
  }
}

export function SystemEvent({ event }: SystemEventProps) {
  const text = getSystemText(event)
  if (!text) return null

  return (
    <div className="flex items-center gap-3 py-1">
      <div className="flex-1 text-center">
        <span className="text-[11px] text-[rgb(var(--np-tx-muted))] italic">
          {text}
        </span>
      </div>
    </div>
  )
}
